// extracted by mini-css-extract-plugin
export default {"Header":"Header_Header__Nm0AY","Title":"Header_Title__Itf1K","SideButtonContainer":"Header_SideButtonContainer__S1LRq"};